import { format, formatDistanceStrict } from 'date-fns';
import { ru } from 'date-fns/locale';

export const formatDate = (date: Date | string | null): string => {
  if (!date) return '';

  if (typeof date === 'string')
    date = new Date(date);

  return format(date, 'd MMM yyyy', { locale: ru });
};

export const formatShortDate = (date: Date | string | null): string => {
  if (!date) return '';

  if (typeof date === 'string') {
    date = new Date(date);
  }

  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear().toString().slice(-2);

  return `${day}.${month}.${year}`;
};

export const formatDateTime = (date: Date | string): string => {
  if (!date) return '';

  if (typeof date === 'string')
    date = new Date(date);

  return format(date, 'd MMM yyyy HH:mm', { locale: ru });
};

export const formatDatePeriod = (startDate: Date | string, endDate: Date| string): string => {
  if (!endDate || !startDate) return '—';
  return formatDistanceStrict(new Date(endDate), new Date(startDate), {
    locale: ru,
    unit: 'day'
  });
};

export const formatShortDatePeriod = (startDate: Date | string | null, endDate: Date | string | null): string => {
  if (!endDate || !startDate) return '—';
  
  const start = new Date(startDate);
  const end = new Date(endDate);

  const diffInMs = end.getTime() - start.getTime();
  const diffInDays = Math.round(diffInMs / (1000 * 60 * 60 * 24));
  
  return `${diffInDays}д.`;
};

export const formatDatesAndPeriod = (startDate: Date |string, endDate: Date|string): string => {
  return `${formatDate(startDate)} - ${formatDate(endDate)} (${formatDatePeriod(startDate, endDate)})`;
};

export const formatShortDatesAndPeriod = (startDate: Date |string, endDate: Date|string): string => {
  return `${formatShortDate(startDate)} - ${formatShortDate(endDate)}(${formatShortDatePeriod(startDate, endDate)})`;
};

export const formatDateMonthYear = (year: number, month: number): string => {
  const months = [
    'январь', 'февраль', 'март', 'апрель', 'май', 'июнь',
    'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь'
  ];
  
  if (month < 0 || month > 11) {
    throw new Error('Месяц должен быть в диапазоне от 0 до 11');
  }

  return `${months[month]} ${year}`;
};

export const getDayText = (days: number): string => {
  if (days % 100 >= 11 && days % 100 <= 14) {
    return 'дней';
  }
  switch (days % 10) {
  case 1: return 'день';
  case 2:
  case 3:
  case 4: return 'дня';
  default: return 'дней';
  }
};
